export const enum InstituteStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  SUSPENDED = 'SUSPENDED'
}

export interface IInstitutes {
  id?: number;
  name?: string;
  status?: InstituteStatus;
  acceptPartialPayment?: boolean;
  mId?: string;
  accountLength?: number;
  billerCode?: string;
  instructions?: string;
  billingCategoryName?: string;
  billingCategoryId?: number;
}

export const defaultValue: Readonly<IInstitutes> = {
  acceptPartialPayment: false
};
